import React from 'react'

export const galleries = {
  "QUEBEC": {
    name: "QUEBEC",
    paths: [
      "quebec-photos",
      "quebecB-photos"
    ],
    thumbs: [
      "quebec-thumbs",
      "quebecB-thumbs"
    ],
    pages: [
      [
        {
          name: () => ('Bending the Light, Mont St. Hilaire'),
          img: '1',
          text: () => (<div>2005<br/>14 X 9  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 13  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 16  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 20  $1300</div>)
        },
        { 
          name: () => (<div>A Farm in Winter,<br/>St. Jean Baptiste<br/>2005</div>),
          layout: 'portrait',
          img: '2',
          text: () => (<div>14 X 9  $375<br/>20 X 13  $650<br/>24 X 16  $900<br/>30 X 20  $1200<br/>40 X 26  $1600</div>)
        },
        { 
          name: () => (<div>Yamaska<br/>2005</div>),
          layout: 'landscape',
          img: '3',
          text: () => (<div>14 X 9  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 11  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 13  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 20  $1300</div>)
        },
        { name: () => ('The Cornfield, Otterburn Park  2005'),
          layout: 'landscape',
          img: '4',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200</div>)
        },
        { name: () => (<div>Denis and Riopelle, Lac Masson<br/>2006</div>),
          layout: 'landscape',
          img: '5',
          text: () => (<div>14 X 6  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 8  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 10  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 12  $1300&nbsp;&nbsp;&nbsp;&nbsp;40 X 28  $1750</div>)
        },
        { name: () => ('Two Houses in a Snowstorm, St. Damase  2006'),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 20  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1300&nbsp;&nbsp;&nbsp;&nbsp;40 X 32  $1750</div>)
        },
      ],
      [
        { name: () => (<div>The Barn  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 6  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 8  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 10  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 12  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 16  $1600</div>)
        },
        { name: () => (<div>The Island, Lac Dupuis<br/>2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 31  $1600</div>)
        },
        { name: () => (<div>The Long Road,<br/>Val Racine<br/>2007</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>11 X 14  $375<br/>16 X 20  $650<br/>19 X 24  $900<br/>24 X 30  $1200<br/>32 X 40  $1600</div>)
        },
        { name: () => (<div>Three Trees, Venise-en-Quebec  2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 32  $1600</div>)
        },
        { name: () => (<div>Mont St. Hilaire, St. Basile-Le-Grand  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 7  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 10  $650</div>)
        },
        { name: () => (<div>The Mystic Mountain, St. Basile-Le-Grand  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 8  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 12  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 14  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 17  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 23  $1600</div>)
        },
      ]
    ]
  },
  "MAINE": {
    name: "MAINE",
    paths: [
      "maine-photos",
      "maineB-photos"
    ],
    thumbs: [
      "maine-thumbs",
      "maineB-thumbs"
    ],
    pages: [
      [
        { name: () => (<div>Two Sailboats, Stockton Harbour<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 14  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 17  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 21  $1300&nbsp;&nbsp;&nbsp;&nbsp;40 X 28  $1750</div>)
        },
        { name: () => (<div>Deer Isle Misty Morning  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1300&nbsp;&nbsp;&nbsp;&nbsp;40 X 28  $1750</div>)
        },
        { name: () => (<div>Clearing Fog on Ogunquit Beach<br/>2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 7  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 10  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 12  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 14  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 19  $1600</div>)
        },
        { name: () => (<div>The Snail<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 9  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 13  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 15  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 19  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 26  $1600</div>)
        },
        { name: () => (<div>Barn Graffiti, Cape Neddick  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200</div>)
        },
        { name: () => (<div>On the Rocks  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 32  $1600</div>)
        },
        { name: () => (<div>Three Boats in the Mist, Cape Elizabeth  2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 6  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 8  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 10  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 12  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 16  $1600</div>)
        },
        { name: () => (<div>Four Boats in the Mist, Cape Elizabeth  2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 6  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 9  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 11  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 14  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 18  $1600</div>)
        },
      ],
      [
        { name: () => (<div>Lady in a Chair, Ogunquit<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 15  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 18  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 22  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 30  $1600</div>)
        },
        { name: () => (<div>Lady on the Beach, Ogunquit<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 15  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 18  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 23  $1300&nbsp;&nbsp;&nbsp;&nbsp;40 X 31  $1750</div>)
        },
        { name: () => (<div>Alone, Ogunquit<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 14  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 15  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 21  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 28  $1600</div>)
        },
        { name: () => (<div>Mommy, Ogunquit<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 14  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 16  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 21  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 27  $1600</div>)
        },
        { name: () => (<div>Casco Bay Sailboat #1, Portland<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 8  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 12  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 15  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 18  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 24  $1600</div>)
        },
        { name: () => (<div>Casco Bay Sailboat #2, Portland<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 14  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 20  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 24  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 30  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 40  $1600</div>)
        },
        { name: () => (<div>Quad Pic, Cape Elizabeth<br/>2007</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>30 X 15  $1200</div>)
        },
        { name: () => (<div>Old Orchard Pier, Old Orchard<br/>2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 5  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 7  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 8  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 11  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 14  $1600</div>)
        },
      ]
    ]
  },
  "SILOS": {
    name: "SILOS",
    paths: [
      "silos-photos",
    ],
    thumbs: [
      "silos-thumbs",
    ],
    pages: [
      [
        { name: () => (<div>Thirteen Silos, St. Jean Baptiste<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 8  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 12  $650</div>)
        },
        { name: () => (<div>Four Silos in Morning Mist, St. Jean Baptiste  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 32  $1600</div>)
        },
        { name: () => (<div>Three Farm Silos, St. Jean Baptiste  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $350&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 20  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 25  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 33  $1600</div>)
        },
        { name: () => (<div>The Silos, St. Philippe de-La Prairie  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $350&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 20  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 25  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 33  $1600</div>)
        },
        { name: () => (<div>Silos in a Snowy Field, St. Jean Baptiste<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 14  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 16  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 21  $1200</div>)
        },
      ]
    ]
  },
  "CEMETERIES": {
    name: "CEMETERIES",
    paths: [
      "cemetaries-photos",
    ],
    thumbs: [
      "cemetaries-thumbs",
    ],
    pages: [
      [
        { name: () => (<div>A Tree,<br/>Mont Royal Cemetery<br/>2006</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>14 X 11  $375<br/>20 X 16  $650<br/>24 X 19  $900<br/>30 X 24  $1200<br/>40 X 32  $1600</div>)
        },
        { name: () => (<div>The Crosses,<br/>Mont Royal Cemetery<br/>2006</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>14 X 11  $375<br/>20 X 16  $650<br/>24 X 19  $900<br/>30 X 24  $1200<br/>40 X 32  $1600</div>)
        },
        { name: () => (<div>Tree and Crosses, Mont Royal Cemetery  2006</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 31  $1600</div>)
        },

      ]
    ]
  },
  "TREES": {
    name: "TREES",
    paths: [
      "trees-photos",
    ],
    thumbs: [
      "trees-thumbs",
    ],
    pages: [
      [
        { name: () => (<div>Two Trees in<br/>a Snowstorm,<br/>St. Pie<br/>2006</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>14 X 12  $375<br/>20 X 17  $650<br/>24 X 20  $900<br/>30 X 25  $1200<br/>40 X34  $1600</div>)
        },
        { name: () => (<div>Cattails<br/>2005</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>14 X 11  $375<br/>20 X 16  $650<br/>24 X 19  $900<br/>30 X 24  $1200<br/>40 X32  $1600</div>)
        },
        { name: () => (<div>A Frozen Leaf  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 15  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 23  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X31  $1600<br/></div>)
        },
        { name: () => (<div>Trees in the Mist, St. Jean Baptiste<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 9  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 13  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 16  $900</div>)
        },
        { name: () => (<div>A Tree in Winter<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 23  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 31  $1600<br/></div>)
        },
        { name: () => (<div>The Naked Tree<br/>2006</div>),
          layout: 'portrait',
          img: '',
          text: () => (<div>14 X 11  $375<br/>20 X 16  $650<br/>24 X 19  $900<br/>30 X 24  $1200<br/>40 X 31  $1600</div>)
        },
      ]
    ]
  },
  "ICE_SHACKS": {
    name: "ICE SHACKS",
    paths: [
      "iceshacks-photos",
    ],
    thumbs: [
      "iceshacks-thumbs",
    ],
    pages: [
      [
        { name: () => (<div>The Red Ice Shack, St. Venise-en-Quebec<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 8  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 12  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 14  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 17  $1200</div>)
        },
        { name: () => (<div>The Pink Ice Shack, St. Venise-en-Quebec<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 15  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 18  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 23  $1200</div>)
        },
        { name: () => (<div>Three Ice Shacks, St. Venise-en-Quebec<br/>2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 10  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 14  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 17  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 22  $1200</div>)
        },
        { name: () => (<div>The Ice Shacks, St. Venise-en-Quebec  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $425&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $750&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $975&nbsp;&nbsp;&nbsp;&nbsp;30 X 24  $1300</div>)
        },
      ]
    ]
  },
  "MISCELLANEOUS": {
    name: "MISCELLANEOUS",
    paths: [
      "misc-photos",
    ],
    thumbs: [
      "misc-thumbs",
    ],
    pages: [
      [
        { name: () => (<div>Fin de Siecle  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 12  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 20  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 25  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 33  $1600</div>)
        },
        { name: () => (<div>Last Winter Snow, Jones Beach, Long Island  2005</div>),
          layout: 'landscape',
          img: '',
          text: () => (<div>14 X 11  $375&nbsp;&nbsp;&nbsp;&nbsp;20 X 16  $650&nbsp;&nbsp;&nbsp;&nbsp;24 X 19  $900&nbsp;&nbsp;&nbsp;&nbsp;30 X 245  $1200&nbsp;&nbsp;&nbsp;&nbsp;40 X 32  $1600</div>)
        },
      ]
    ]
  },
}



// WEBPACK FOOTER //
// ../messages/galleries.js